import { render, staticRenderFns } from "./p295_donation.vue?vue&type=template&id=6a6f8744"
import script from "./p295_donation.vue?vue&type=script&lang=js"
export * from "./p295_donation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Panel: require('/root/containers/hermes_eshop/components/hyper/p295/panel.vue').default})
